/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, imageTypes } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED PARTNER LOGO : STYLES --------------- ++++++++++ */
export default theme => ({
	partnerlogo: {
		cursor: 'pointer',
		display: 'inline-block',
		extend: imageTypes.logo,
		// background image comes from component and is dynamic from store
		backgroundPosition: '100% 50%',
		width: pxToEm(110),
		height: pxToEm(32),
		position: 'relative',
		zIndex: '3',
		'&:hover': {
			animationName: 'pulse',
            animationDelay: '0s',
            animationDuration: '.5s'
		},
		'&.clickable-false': {
			pointerEvents: 'none',
			cursor: 'default'
		}
	}
});
